module.exports = __webpack_public_path__ + "c55fe90a8f6bafe1d077a7afa102da87.png";